export default "__VITE_ASSET__C9kJ7PxM__"